export const DIGITAL_SYSTEM_INCREMMENT = "digital_system_incremment";
export const DIGITAL_SYSTEM_DECREMMENT = "digital_system_decremment";
export const DIGITAL_BILL_DEPOSIT = "digital_bill_deposit";
export const REFOUND = "refound";
export const DIGITAL_LIQUIDATION = "digital_liquidation";
export const DIGITAL_PAYMENT = "digital_payment";
export const DIGITAL_RECHARGE = "digital_recharge";
export const DIGITAL_WITHDRAW = "digital_withdraw";
export const DIGITAL_TRANSFER_SENDED = "digital_transfer_sended";
export const DIGITAL_TRANSFER_RECEIVED = "digital_transfer_received";
export const DIGITAL_SWIPE_TRANSFER_INCREMMENT = "digital_swipe_transfer_incremment";
export const DIGITAL_SWIPE_TRANSFER_DECREMMENT = "digital_swipe_transfer_decremment";
